<template>
  <div id="record">
    <img src="@/assets/top.png" class="top" />
    <div class="nav">
      <div class="left" @click="toUrl()">
        <van-icon name="arrow-left" size="20" />
      </div>

      <div class="center">
        详情
        <!-- <img src="@/assets/logo.png" width="21" />
        <span style="margin-left:0.3rem">青山湖区智慧残联</span>-->
      </div>
      <div class="right" @click="toHome()" >
        <van-icon name="manager" size="21"/>
      </div>
    </div>
          <van-loading size="24px" class="padding" v-show="showL" style="text-align:center">加载中...</van-loading>
    <div class="padding content" v-show="showDiv">
      <div class="info" v-if="info.reply==''">暂无回复</div>
      <div class="info" v-else>回复：{{info.reply}}</div>
      <div class="btn" :class="{'btn1':status==1,'btn2':status==3,'btn3':status==4}" @click="toCancel()">
        <span v-if="status==1">取消申请</span>
        <span v-if="status==2">已取消</span>
        <span v-if="status==3">已通过</span>
        <span v-if="status==4">已拒绝</span>
      </div>
    </div>
    <van-dialog v-model="show" title="提示" show-cancel-button :beforeClose="beforeClose">
      <div style="margin:1.5rem 0">确定要取消申请吗？</div>
    </van-dialog>
  </div>
</template>
<script>
import { Icon, Dialog, Toast ,Loading} from "vant";
import { applyInfo, cancelApply } from "@/api/apiData";
import { formatDate } from "@/public/getFormatDate.js";
export default {
  components: {
    [Icon.name]: Icon,
    [Dialog.Component.name]: Dialog.Component,
    [Toast.name]: Toast,
    [Loading.name]: Loading,
  },
  data() {
    return {
      info: [],
      type: "",
      token: "",
      show: false,
      id: "",
      status: "",
      showL:true,
      showDiv:false
    };
  },
  filters: {
    //方法一: yyyy-MM-dd hh:mm
    formatDate(time) {
      time = time * 1000;
      let date = new Date(time);
      console.log(date);
      return formatDate(date, "yyyy-MM-dd hh:mm");
    },
  },
  mounted() {
    let id = this.$route.query.id;
    var token = localStorage.getItem("tokenC");
    this.id = id;
    this.token = token;
    this.getIntro(id);
  },
  methods: {
    toUrl() {
      this.$router.go(-1);
    },
    toHome() {
      this.$router.push("/mine");
    },
    getIntro(id) {
      applyInfo({ id: id, token: this.token }).then((res) => {
        this.info = res.data;
        this.status = res.data.status;
        this.showL = false;
        this.showDiv = true
      });
    },
    toCancel() {
      if (this.status == 1) {
        this.show = true;
      }
    },
    beforeClose(action, done) {
      if (action === "confirm") {
        cancelApply({ id: this.id, token: this.token }).then((res) => {
          setTimeout(done);
          Toast(res.message);
          this.$router.push("/applyList");
        });
      } else {
        done();
      }
    },
  },
};
</script>
<style scoped>
.info {
  font-size: 0.9rem;
  margin: 1rem;
  color: #504e4e;
  text-align: left;
}
.btn {
  width: 95%;
  margin: 0 auto;
  background: #eee;
  color: #959595;
  line-height: 2rem;
  height: 2rem;
  border-radius: 5px;
}
.btn1 {
  background: #73b850;
  color: white;
}
.btn2{
  background: green;
  color: white;
}
.btn3{
  background: red;
  color: white;
}
</style>


// WEBPACK FOOTER //
// src/page/applyInfo.vue